import React from 'react'
import { StoreProvider } from 'easy-peasy'
import store from './store'
import MainModal from './pages/MainModal'
import Main from './pages/Main'
import MainLanding from './pages/MainLanding'
import MainConsumer from './pages/MainConsumer'
import './styles/index.scss'

function App({ data, localeItems, locale }) {
  return (
    <StoreProvider store={store({ data, localeItems, locale })}>
      <div className="container">
        {data.config.type === 'modal-form' && <MainModal />}
        {data.config.type === 'only-form' && <Main />}
        {data.config.type === 'landing-form' && <MainLanding />}
      </div>
      {data.config.type === 'landing-consumer' && <MainConsumer />}
    </StoreProvider>
  )
}

export default App
